import React, { useContext } from "react";
import ArticleOverview from "./ArticleOverview";
import NoResults from "./NoResults";
import "./NoResults.css";
import { SearchContext } from "./../searchContext";

const ShowResults = (props) => {
  const [searchState, setSearchState] = useContext(SearchContext);
  if (searchState.searchValue.length !== 0) {
    if (
      searchState.searchValue.length !== 0 &&
      searchState.searchResults === "none found"
    ) {
      return <NoResults />;
    }
    if (
      searchState.searchResults !== null &&
      searchState.searchResults.length > 0
    ) {
      console.log("results found - " + searchState.searchResults.length);
      return searchState.searchResults.map((r, index) => {
        return (
          <ArticleOverview
            key={index}
            paperTitle={r.title._text || ""}
            paperAbstract={r.summary._text || ""}
          />
        );
      });
    }
    if (searchState.searchResults !== null) {
      console.log("1 result found");
      return (
        <ArticleOverview
          paperTitle={searchState.searchResults.title._text || ""}
          paperAbstract={searchState.searchResults.summary._text || ""}
        />
      );
    }
  }
  return "";
};

export default ShowResults;
